// extracted by mini-css-extract-plugin
module.exports = {"text":"SocialColumn_text__VFYkC","link":"SocialColumn_link__j1HWi","icon":"SocialColumn_icon__m7ZmJ"};